// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JEpfU","inner":"styles_inner__1Z1rV","right":"styles_right__LZo4P","close":"styles_close__7rEwX","footer":"styles_footer__1scsn"};